import { createFileRoute } from '@tanstack/react-router'

import { connectionQuery, exportSummaryQuery } from '../lib/queries'
import { Export } from '../screens/Export'

export const Route = createFileRoute('/export')({
  validateSearch: (search: Record<string, unknown>): { from?: string; to?: string } => ({
    from: typeof search.from === 'string' ? search.from : undefined,
    to: typeof search.to === 'string' ? search.to : undefined,
  }),
  loaderDeps: ({ search }) => ({ from: search.from, to: search.to }),
  loader: ({ context, deps }) =>
    Promise.all([
      context.queryClient.ensureQueryData(exportSummaryQuery(deps.from, deps.to)),
      context.queryClient.ensureQueryData(connectionQuery()),
    ]),
  component: Export,
})
